import api from '../config/axios'; // your preconfigured axios instance

export default async function updatePersonalInfo(token, payload) {
  try {
    const res = await api.put('/me/personal', payload, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data; // <-- Axios uses res.data
  } catch (err) {
    // Normalize error message
    const msg =
      err?.response?.data?.message ||
      err?.response?.data ||
      err.message ||
      'Request failed';
    throw new Error(msg);
  }
}
